import React from 'react';

import { dateToDisplay } from '../../webcommon/common/helpers';
import Symbol from '../../webcommon/common/symbols/Symbol';

export default (useDollars = false, beginDate, endDate) => {
    const currencyString = useDollars ? 'Usd' : 'Eur';

    return [
        {
            sortable: true,
            id: 'counterparty',
            title: 'Counterparty'
        },
        {
            id: 'PAYMENT_HEADER',
            Header: () => <Symbol symbol={ currencyString.toUpperCase() }>IM Posted</Symbol>,
            columns: [
                {
                    id: `firstDayPledge${currencyString}`,
                    idWithoutCurrency: 'firstDayPledge',
                    title: beginDate ? dateToDisplay(beginDate) : '',
                    type: 'number',
                    sortable: true,
                    width: 120
                },
                {
                    id: `lastDayPledge${currencyString}`,
                    idWithoutCurrency: 'lastDayPledge',
                    title: endDate ? dateToDisplay(endDate) : '',
                    type: 'number',
                    sortable: true,
                    width: 120
                },
                {
                    id: `pledgeDiff${currencyString}`,
                    idWithoutCurrency: 'pledgeDiff',
                    title: 'Difference',
                    type: 'number',
                    sortable: true,
                    width: 120
                }
            ]
        }
    ];
};
